import { ColumnData, SlideAction, useSlidePanel } from '@gripp/shared-ui';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetDetailPanel = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  const column = useMemo<ColumnData | null>(() => {
    if (!assetId) return null;
    return {
      title: 'assets.menu.title',
      mainComponent: <AssetCard assetId={assetId} />,
      headerComponent: <AssetFilters assetId={assetId} />,
      showBackButton: true,
      backButtonTransition: SlideAction.SINGLE,
      onBackButtonPress: () => navigate('/assets'),
    };
  }, [assetId, navigate]);

  useSlidePanel('right', column, [column]);

  return null;
};
